
import { computed, watch, defineComponent, ref } from "vue";
import router from "@/router";
import {
  VueDatePicker,
} from "@vuepic/vue-datepicker";
import Swal from "sweetalert2";
import {
  bankNames,
  bankAccountTypes,
  UserFetchData,
} from "@/services/auth/types";
import { useUserStore } from "@/stores/user";
import { AuthService } from "@/services/auth/AuthService";
import {
  isNullOrEmpty,
  reformatDateISO8601,
  validateRut,
} from "@/services/utils";
import ChangePasswordForm from "@/components/molecules/ChangePasswordForm.vue";

import TextField from "@/components/atoms/TextField.vue";

export default defineComponent({
  components: { TextField, ChangePasswordForm },

  data() {
    return {
      showModal: false,
    };
  },

  setup() {
    const showChangePasswordModal = ref<boolean>(false);
    const shareholderStore = useUserStore();
    const changed = ref<boolean>(false);
    const flow = ref<VueDatePicker["flow"]>(["month", "calendar"]);

    const shareholder = computed(() => shareholderStore.shareholder);
    const shareholderId = computed(() =>
      Number(router.currentRoute.value.params.id)
    );
    type userResponse = {
      detail: string;
    };
    watch(
      shareholder,
      (value, oldValue) => {
        if (oldValue != undefined) {
          changed.value = true;
        }
      },
      { deep: true }
    );
    const investorNumberA = ref<number | null>(null);
    const investorNumberB = ref<number | null>(null);

    const rutFieldHasError = computed(() => {
      if (shareholder.value == undefined) return true;
      return (
        isNullOrEmpty(shareholder.value.rut) ||
        !validateRut(shareholder.value.rut)
      );
    });
    const authService = new AuthService();
    watch(
      shareholder,
      (newShareholder) => {
        if (newShareholder) {
          investorNumberA.value = newShareholder.investorNumberA
            ? newShareholder.investorNumberA
            : 0;
          investorNumberB.value = newShareholder?.investorNumberB
            ? newShareholder?.investorNumberB
            : 0;
        }
      },
      { immediate: true }
    );
    async function setWritingDate(date: string) {
      if (shareholder.value == undefined) return;
      shareholder.value.writingDate = reformatDateISO8601(new Date(date));
    }

    async function submitUser() {
      if (shareholder.value == undefined || rutFieldHasError.value) {
        Swal.fire("Error!", "Algo no está en orden", "error");
        return;
      }

      // investorNumberA.value = investorNumberA.value ? investorNumberA.value : null;
      // investorNumberB.value = investorNumberB.value ? investorNumberB.value : null;
      let userFetchData = new UserFetchData(
        shareholder.value.firstName,
        shareholder.value.lastName,
        shareholder.value.rut,
        shareholder.value.email,
        shareholder.value.phone,
        shareholder.value.address,
        shareholder.value.bankName,
        shareholder.value.bankCode,
        shareholder.value.accountType,
        shareholder.value.accountNumber,
        shareholder.value.accountOwnerName,
        shareholder.value.accountOwnerRut,
        shareholder.value.accountEmail,
        shareholderId.value,
        shareholder.value.county,
        shareholder.value.region,
        investorNumberA.value == shareholder.value.investorNumberA
          ? null
          : investorNumberA.value,
        investorNumberB.value == shareholder.value?.investorNumberB
          ? null
          : investorNumberB.value,
        0,
        0,
        0,
        shareholder.value.businessName ?? "",
        shareholder.value.businessAddress ?? "",
        shareholder.value.businessRut ?? "",
        shareholder.value.writingDate ?? "",
        shareholder.value.notary ?? "",
        shareholder.value.notaryCity ?? "",
        shareholder.value.repertoireNumber ?? ""
      );
      const response = await authService.editUser(userFetchData);
      if (response.success) {
        shareholderStore.query(shareholderId.value);
        Swal.fire(
          "¡Listo!",
          "El usuario se ha modificado con éxito",
          "success"
        );
      } else {
        const responseData = response.data as userResponse;
        alert(responseData.detail);
        Swal.fire(
          "Error!",
          "Lo sentido, ha ocurrido un error, intente nuevamente",
          "error"
        );
      }
    }

    // Método para abrir el modal
    function openChangePasswordModal() {
      showChangePasswordModal.value = true;
    }

    return {
      changed,
      shareholder,
      investorNumberA,
      investorNumberB,
      showChangePasswordModal,
      openChangePasswordModal,
      bankNames,
      bankAccountTypes,
      submitUser,
      flow,
      setWritingDate,
      rutFieldHasError,
    };
  },
});
